/**
 * Full-width bar at the very top of every page naming the environment, so nobody mistakes
 * a development or staging app for production. Driven by the server: `ui-context` carries
 * `environmentBanner` from `vars.environmentBanner`, which production leaves unset.
 *
 * Rendered above the routed page in normal flow (not fixed), so the admin shell's sticky
 * sidebar and header keep their own top edge once the page scrolls. Legacy Tailwind
 * classes on purpose: this sits outside both the classic and the new-design shells.
 */
export default function EnvironmentBanner({ label }: { label: string | null | undefined }) {
  if (label == null || label.trim() === "") {
    return null;
  }
  return (
    <div
      role="note"
      aria-label={`${label}, ${window.location.hostname}`}
      className="flex w-full items-center justify-center gap-2 bg-amber-300 px-3 py-1 text-xs font-medium leading-5 text-amber-950"
    >
      <span className="uppercase tracking-wide">{label}</span>
      <span aria-hidden className="opacity-60">
        {window.location.hostname}
      </span>
    </div>
  );
}
